import { Link } from "react-router-dom";
import FaqsSection from "./FaqsSection";
import OnDemandSection from "./OnDemandSection";
import personalCover from "../assets/landing/property-handshake.jpeg";
import businessCover from "../assets/landing/signing-documents.jpeg";
import storyBusiness from "../assets/landing/reviewing-papers.jpeg";

const ASSURANCES = [
  {
    title: "Risk free",
    desc: "Choose the wrong Click Law service? Switch to a more suitable option without unnecessary hassle.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3.2 19 6v5.1c0 4.6-3.2 8.6-7 9.8-3.8-1.2-7-5.2-7-9.8V6l7-2.8z" />
        <path d="M9.2 12.6 11 14.4 14.8 10.6" />
      </svg>
    ),
  },
  {
    title: "No hidden fees",
    desc: "Subscription pricing is shown clearly before you sign up. The price you see is the price you pay.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v10M9.5 10.2h3.4a1.8 1.8 0 0 1 0 3.6H9.5" />
      </svg>
    ),
  },
  {
    title: "No unused hours",
    desc: "Unused hours roll over according to the terms of your service, so available legal support is not simply lost at month end.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </svg>
    ),
  },
];

const STORIES = {
  personal: [
    {
      eyebrow: "Services",
      title: "Legal support that fits everyday life in the UAE",
      body: [
        "Click Law connects individuals and families with licensed legal professionals for common personal matters — tenancy, employment, family issues, and day-to-day legal questions.",
        "Choose a service, submit a request, and get matched without having to search the legal market on your own.",
      ],
      image: personalCover,
      alt: "Handshake after a personal legal agreement",
      cta: { to: "/contact", label: "Talk to us" },
    },
   
  ],
  business: [
    {
      eyebrow: "Services",
      title: "A defined legal allowance for your company",
      body: [
        "Give your team access to legal hours for contracts, compliance, employment, and everyday business decisions.",
        "Click Law services are designed so UAE companies know what they are paying for before they start — with a clear allowance and a simple way to request support.",
      ],
      image: businessCover,
      alt: "Signing legal documents with a lawyer",
      cta: { to: "/contact", label: "Talk to us" },
    },
    {
      eyebrow: "How it works",
      title: "Matched with the right legal support",
      body: [
        "Once your business is subscribed, submit a request and Click Law assigns a verified lawyer or firm for the matter.",
        "Keep communication, meetings, and documents in one secure platform while you stay focused on running the company.",
      ],
      image: storyBusiness,
      alt: "Reviewing legal papers during a consultation",
    },
  ],
};

export default function PlansExtras({ type = "personal", showOnDemand = true }) {
  const stories = STORIES[type] || STORIES.personal;

  return (
    <>
      {/* <section className="cl-plan-assurances">
        <div className="cl-container">
          <div className="cl-plan-assurances-head">
            <p className="cl-eyebrow center">Why subscribe</p>
            <h2 className="cl-title center">Straightforward services with Click Law</h2>
          </div>
          <div className="cl-plan-assurances-grid">
            {ASSURANCES.map((item) => (
              <article className="cl-plan-assurance-card" key={item.title}>
                <div className="cl-plan-assurance-icon">
                  <span>{item.icon}</span>
                </div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section> */}

      {stories.map((story, index) => (
        <section
          className={`cl-plan-story${index % 2 === 1 ? " is-reverse" : ""}${index % 2 === 1 ? " is-alt" : ""}`}
          key={story.title}
        >
          <div className="cl-container cl-plan-story-grid">
            <div className="cl-plan-story-media">
              <img src={story.image} alt={story.alt} />
            </div>
            <div className="cl-plan-story-copy">
              <p className="cl-eyebrow">{story.eyebrow}</p>
              <h2>{story.title}</h2>
              {story.body.map((para) => (
                <p key={para}>{para}</p>
              ))}
              {story.cta ? (
                <Link to={story.cta.to} className="btn btn-solid">
                  {story.cta.label}
                </Link>
              ) : null}
            </div>
          </div>
        </section>
      ))}

      {showOnDemand ? <OnDemandSection /> : null}
      <FaqsSection />
    </>
  );
}
